import { gql } from '@anyx/common-graphql';

export const GET_CUSTOMER_TAGS = gql(/* GraphQL */ `
  query GetCustomerTags($input: GetCustomerTagsRequest!, $getCount: Boolean = false) {
    CustomerTags(input: $input) {
      customerTags {
        name
        ... @include(if: $getCount) {
          taggedCount
        }
      }
    }
  }
`);

export const GET_CUSTOMER_TAGS_V2 = gql(/* GraphQL */ `
  query GetCustomerTagsV2($input: GetCustomerTagsRequest!, $getCount: Boolean = false) {
    CustomerTags(input: $input) {
      customerTags {
        id
        name
        isInfluencerTag
        ... @include(if: $getCount) {
          taggedCount
        }
      }
    }
  }
`);

export const GET_STORE_AI_AUTO_REPLY_SETTING = gql(/* GraphQL */ `
  query GetStoreSetting($input: FetchAIAutoReplyStoreSettingInput!) {
    getStoreSetting(input: $input) {
      contextConfigId
      hasAiFooter
    }
  }
`);

export const GET_CUSTOMER_NOTES = gql(/* GraphQL */ `
  query CustomerNotes(
    $customerGroupId: String!
    $channelCustomer: ChannelCustomerInput
    $keyword: String
    $after: String
    $limit: Int!
  ) {
    CustomerNotesV3(
      input: {
        customerGroupId: $customerGroupId
        channelCustomer: $channelCustomer
        keyword: $keyword
        after: $after
        limit: $limit
      }
    ) {
      ...CustomerNoteFields
    }
  }
`);

export const CUSTOMER_ACTIVITY_V4 = gql(/* GraphQL */ `
  query CustomerActivityV4(
    $customerGroupId: String!
    $channelCustomerFilter: ChannelCustomerInput
    $olderThan: String
    $limit: Int!
  ) {
    CustomerActivitiesV4(
      input: {
        customerGroupId: $customerGroupId
        channelCustomerFilter: $channelCustomerFilter
        olderThan: $olderThan
        limit: $limit
      }
    ) {
      total
      records {
        id
        timestamp

        ...CustomerActivityV4_CustomerCreated
        ...CustomerActivityV4_InfluencerJoinedCampaign
        ...CustomerActivityV4_InfluencerPublishedPost
        ...CustomerActivityV4_InfluencerSubmittedPost
        ...CustomerActivityV4_OptIn
        ...CustomerActivityV4_Ordered
        ...CustomerActivityV4_ProfileUpdated
      }
    }
  }
`);
